import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { formDataGenerator, getRouting } from "../../../../../utils/common";
import { getnewStatutoryContent } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PaginationComponent from "../../../general/PaginationComponent";

const InvestorComplaints = (props) => {
  const {
    getnewStatutoryContent,
    statutoryInvestorComplaints,
    location: { pathname },
  } = props;

  const [complaints, setcomplaints] = useState();
  const [defaultYear, setdefaultYear] = useState();
  const [metaData, setmetaData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [flag , setFlag] = useState(false);

  const getPaginatedData = (page) => {
    loadData(page);
  };

  useEffect(() => {
    let pageType = "data-on-investor-complaints";
    let formData = {
      disclosuresPage: "data-on-investor-complaints",
      year: defaultYear ? defaultYear :'',
      limit: limit,
      offset: 0,
    };
    !(statutoryInvestorComplaints && statutoryInvestorComplaints.investorComplaintsData && flag == false) && getnewStatutoryContent({},formDataGenerator(formData), pageType);
  }, [defaultYear]);

  useEffect(() => {
    if (
      statutoryInvestorComplaints &&
      statutoryInvestorComplaints.investorComplaintsData
    ) {
      setcomplaints(statutoryInvestorComplaints.investorComplaintsData);
    }
    if(statutoryInvestorComplaints &&
      statutoryInvestorComplaints.investorComplaintsData &&
      statutoryInvestorComplaints.investorComplaintsData.meta){
      setmetaData(statutoryInvestorComplaints.investorComplaintsData.meta);
    }
    if(statutoryInvestorComplaints &&
      statutoryInvestorComplaints.investorComplaintsData &&
      statutoryInvestorComplaints.investorComplaintsData.total){
      setTotalRecords(statutoryInvestorComplaints.investorComplaintsData.total);
    }
  }, [statutoryInvestorComplaints]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSelectChange=(e)=>{
    setdefaultYear(e.target.value);
    setActivePage(1);
    setFlag(true);
  }

  const loadData = (page) => {
    let pageType = "data-on-investor-complaints";
    const offsetValue = limit * (page - 1);
    let params = {
      disclosuresPage: "data-on-investor-complaints",
      limit: limit,
      offset: limit * (page - 1),
      year: defaultYear?defaultYear:''
    };
    getnewStatutoryContent({},formDataGenerator(params), pageType);
    let unit = window.innerHeight / 100;
    window.scrollTo({ top: 40 * unit });
  };


  return (
    <div className="wrapper">
      {metaData ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta
            property="og:title"
            content={metaData && metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta
            property="og:image"
            content={metaData && metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData && metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      ) : (
        ""
      )}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="dropdown me-auto">
              <div>
                <h1>
                  <span>Investor </span>Complaints
                </h1>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item d-flex">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  <a href="/statutory-disclosure">Statutory Disclosure</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className="container py-5">
          <div className="row mb-4">
            <div className="col-md-4">
              {/* <p class="fsize mb-2">View by fiscal year</p> */}
              <div className="input-group inputt">
                <select
                  className="form-select py-3"
                  aria-label="Example select with button addon"
                  onChange={handleSelectChange}
                >
                  {complaints &&
                    complaints.filters &&
                    complaints.filters.years &&
                    Object.keys(complaints.filters.years).length > 0 &&
                    Object.keys(complaints.filters.years).reverse().map((year, yearindex) => {
                      return (
                        <option value={year}>
                          {
                            Object.values(
                              complaints.filters.years
                            ).reverse()[yearindex]
                          }
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </div>

          <div className="row pt-4">
            <div className="col-md-12">
              {complaints &&
                complaints.files &&
                complaints.files.length > 0 &&
                complaints.files.map((item, index) => {
                  return (
                    <a href={item.file && item.file.url ? item.file.url : ""} target="_blank">
                      <div className="bgw d-flex justify-content-between align-items-center p-4 mx-0 mb-3">
                        <div className="d-flex align-items-center">
                          <img
                            src="/images/New/StatutoryDisclosures/excel.svg"
                            alt="excel"
                          />
                          <h2 className="text ms-2">{item.title}</h2>
                        </div>
                        <div className="d-flex justify-content-end">
                          <img
                            src="/images/New/StatutoryDisclosures/download.svg"
                            alt="download"
                          />
                        </div>
                      </div>
                    </a>
                  );
                })}
            </div>
          </div>
          {totalRecords > 10 && (
            <div className="row my-4">
              <div className="col-md-12">
                <div className="paginate d-flex justify-content-center">
                  <PaginationComponent
                    totalRecords={totalRecords}
                    activePage={activePage}
                    setActivePage={setActivePage}
                    data={data}
                    limit={limit}
                    getPaginatedData={getPaginatedData}
                    itemsCountPerPage={limit}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
const mapStateToProps = (state) => ({
  statutoryInvestorComplaints: state.StatutoryDisclosures,
});

const mapDispatchToProps = (dispatch) => ({
  getnewStatutoryContent: bindActionCreators(getnewStatutoryContent, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestorComplaints);
